import React from 'react';
import {
    PanelHeader,
    Div,
    Spinner,
    SplitCol,
    SplitLayout,
    Button,
    Search, ButtonGroup, ModalPage, ModalPageHeader, PanelHeaderButton, ModalRoot, Alert, FormItem, Textarea
} from '@vkontakte/vkui';
import axios from "axios";

import {
    Icon24Cancel, Icon24Done
} from "@vkontakte/icons";
import IncomingProducts from "./IncomingProducts";
import {AdaptivityContext, setQuizStep} from "../assets/constants";
import * as constants from "../assets/constants";

import IncomingStepHeader from "./StepHeader";


class IncomingStep4 extends React.Component {

    state = {
        mainSearch: '',
        items: [],
        cnt_products: 0,
        loading: true,
        showAlertSend: false,
        modalHistory: [],
        activeModal: null,
        docComment: ''
    }

    constructor(props) {
        super(props);
        this.modalBack = () => {
            this.setActiveModal(this.state.modalHistory[this.state.modalHistory.length - 2])
        };
    }

    setActiveModal(activeModal) {
        activeModal = activeModal || null;
        let modalHistory = this.state.modalHistory ? [...this.state.modalHistory] : [];

        if (activeModal === null) {
            modalHistory = [];
        } else if (modalHistory.indexOf(activeModal) !== -1) {
            modalHistory = modalHistory.splice(0, modalHistory.indexOf(activeModal) + 1);
        } else {
            modalHistory.push(activeModal);
        }

        this.setState({
            activeModal,
            modalHistory
        });
    };


    getItems = () => {
        clearInterval(this.searchInterval);

        this.setState({loading: true})

        let body = new FormData()
        body.append('ids', JSON.stringify(this.props.ids))

        axios.post(this.props.base_url + '?app=incomings&act=getDocItems', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            this.setState({loading: false, items: response.data.items ?? []})


            this.setState({cnt_products: response.data.items ? response.data.items.length : 0})

        })

    }

    componentDidMount() {
        setTimeout(() =>
            this.getItems(), 500)
    }

    onSearchChange = (e) => {
        this.setState({mainSearch: e.target.value})
    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');


        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>

                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_SEND_ORDER}
                           onClose={this.modalBack}

                           style={{
                               width: "100%", marginBottom: "100px"
                           }}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Завершение приемки товаров
                               </ModalPageHeader>
                           }
                >
                    <Div>Завершить приемку товаров и отправить в 1С?</Div>
                    <FormItem top="Комментарий">
                        <Textarea autoFocus value={this.state.docComment} rows={7} placeholder="Можно оставить пустым"
                                  onChange={e => this.setState({docComment: e.currentTarget.value})}/>
                    </FormItem>
                    <Div style={{marginBottom: '100px'}}>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button before={<Icon24Done/>} size="l" stretched
                                    onClick={() => this.sendIncoming()}>Да</Button>
                            <Button before={<Icon24Cancel/>} size="l" stretched
                                    onClick={() => this.setActiveModal(null)}>Нет</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>
            </ModalRoot>

        );

        const alertSend = <Alert
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Нет',
                    action: () => this.setState({showAlertSend: false}),
                    mode: 'cancel',
                },
                {
                    title: 'Да',
                    autoClose: true,
                    mode: 'destructive',
                    action: () => {
                        this.setState({showAlertSend: false});
                        this.sendIncoming()
                    },
                },
            ]}
            onClose={() => this.setState({showAlertSend: true})}
            header="Завершить приемку товаров и отправить в 1С?"
            text={
                <FormItem top="Комментарий">
                    <Textarea autoFocus value={this.state.docComment} rows={7} placeholder="Можно оставить пустым"
                              onChange={e => this.setState({docComment: e.currentTarget.value})}/>
                </FormItem>
            }
        />


        return (
            <SplitLayout modal={modals}>
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Приемка. Шаг 4
                        </Div>
                    </PanelHeader>
                    <IncomingStepHeader currentDocs={this.props.currentDocs} onSearchChange={this.onSearchChange}
                                        step={4}/>
                    <SplitLayout>
                        <SplitCol>
                            {this.state.loading ? <Spinner size="large"/> :
                                <IncomingProducts items={this.state.items}
                                                  search={this.state.mainSearch}
                                                  base_url={this.props.base_url}
                                                  current_user={this.props.current_user}
                                                  images_url={images_url}
                                                  readonly
                                                  getColors
                                                  currentDocs={this.props.currentDocs}/>}
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div className="action-board">
                                <ButtonGroup mode="horizontal" stretched>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(3, 'Incoming')}>Назад</Button>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => this.setActiveModal(constants.MODAL_SEND_ORDER)}
                                    >Завершить</Button>
                                </ButtonGroup>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                </SplitCol>
            </SplitLayout>)
    }

    loadImages = () => {
        const data = localStorage.getItem(constants.photo_incomings_key)
        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            return items
        }
        return []
    }

    loadImagesDefective = () => {
        const data = localStorage.getItem(constants.photo_defective_act_key)
        if (data && data !== "undefined") {
            const allItems = JSON.parse(data)

            return allItems
        }
        return {}
    }
    loadDataDefective = () => {
        const dataDef = localStorage.getItem(constants.data_defective_act_key)
        if (dataDef && dataDef !== "undefined") {
            const data = dataDef ? JSON.parse(dataDef) : {}
            return data
        }

        return {}
    }

    sendIncoming = () => {
        const images_url = this.props.images_url
        const data = localStorage.getItem(constants.values_incomings_key)

        let values = {}
        if (data && data !== "undefined") {
            values = JSON.parse(data)

        }
        const images_ = this.loadImages()
        const imagesDefective = this.loadImagesDefective()
        const dataDefective = this.loadDataDefective()

        const products = []

        const items = this.state.items

        Object.keys(images_).map((key) => {

            delete images_[key].hasImage
        })
        const images = {}
        Object.keys(images_).map((key) => {

            images["C" + key] = images_[key]
        })
        items.map((item) => {
            const qnt = values[item.GUID]?.qnt ?? 0
            const series = values[item.GUID]?.series ?? []
            item.quantity = item.quantity * 1

            const {name, external_id, quantity} = item

            const newItem = {name, external_id, quantity}


            newItem.realQnt = qnt
            newItem.series = series

            if (dataDefective[item.GUID]) {

                const defData = dataDefective[item.GUID]
                const defimages_ = imagesDefective[item.GUID] ?? []

                Object.keys(defimages_).map((key) => {

                    delete defimages_[key].hasImage
                })
                const defimages = {}
                Object.keys(defimages_).map((key) => {

                    defimages["C" + key] = defimages_[key]
                })
                newItem.defectiveAct = {...defData, images: defimages}
            }
            products.push(newItem)

        })


        const docs_ = this.props.currentDocs

        const docs = {}
        Object.keys(docs_).map((key) => {

            docs["D" + key] = docs_[key]
        })

        const incoming = {
            date: new Date(),
            images: images,
            username: this.props.current_user.name,
            comment: this.state.docComment,
            docs: docs,
            products: products
        }


        console.log(JSON.stringify(incoming))
        window.postMessage({type: 'success', text: "Выгружаем приемку в 1С, не закрывайте окно!", timeout: 10000})
        const body = new FormData()
        body.append('json', JSON.stringify(incoming));
        this.setActiveModal(null)
        let sAjaxSource = '/?app=incomings&act=exportIncomingToWebService'

        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }

            }
        ).then((response) => {
            window.postMessage({type: 'endIncoming'})
        })

    }


}

export default IncomingStep4